import { ChangeStoryDueDateMeta, ChangeStoryDueDatePayload } from 'types/store/ChangeStoryDueDate';
import { createAsyncReducer } from 'utils/Redux';

import { changeStoryDueDateActions } from '../actions';

export default createAsyncReducer<ChangeStoryDueDateMeta, ChangeStoryDueDatePayload>(changeStoryDueDateActions);
